import { arrayOf, number } from "prop-types";
import MoscowRegionMap from "maps/regionMaps/MoscowRegionMap";
import { regionIds } from "utils/reports/RegionIds";

export default function RegionMap({ regionId, highlightedRegions }) {
    switch (regionId) {
        case regionIds.MoscowRegionId:
            return <MoscowRegionMap highlightedRegions={highlightedRegions} />;
        default:
            return null;
    }
}

RegionMap.propTypes = {
    regionId: number.isRequired,
    highlightedRegions: arrayOf(number).isRequired,
};
